import './style.scss';

import * as XLSX from 'xlsx';
import xls from '../../assets/icons/xls.svg';
import { useEffect, useState } from 'react';

function DownloadAttendances({ attendances }) {
  const [attendancesInfo, setAttendancesInfo] = useState([]);

  function generateInfo() {
    const info = attendances.attendancesModel.map(a => {
      const meeting = attendances.meetings.find(
        m => m.id === a.meeting_group_id
      );
      const group = attendances.groups.find(g => g.id === meeting?.group_id);
      let meetingName = meeting?.type === 'MEETING' ? 'Encuentro' : 'Evento';
      meetingName = `${meetingName} ${meeting.order}`;
      let meetingDate = '';
      const idx = a.attendance_date.indexOf('T');
      if (idx > 0) {
        meetingDate = a.attendance_date.substring(0, idx);
      } else {
        meetingDate = a.attendance_date;
      }
      return {
        ESCUELA: group?.school?.code,
        COMUNA_ID: group.municipality?.id,
        COMUNA: group.municipality?.name,
        BARRIO_ID: group.neighborhood?.id,
        BARRIO: group.neighborhood?.name,
        ID_GRUPO: group?.id,
        GRUPO: group?.code,
        TIPO_RECURSO: group.school?.resource_type_id,
        TIPO_ESCUELA: group.school?.type,
        ID_REGISTRO_ASISTENCIA: a.id,
        ID_ENCUENTRO: a.meeting_group_id,
        NOMBRE_ENCUENTRO: meetingName,
        FECHA_ASISTENCIA: meetingDate,
        BENEFICIARIO_TIPO_DOC: a.beneficiary?.document_type,
        BENEFICIARIO_DOCUMENTO: a.beneficiary?.document,
        BENEFICIARIO: a.beneficiary?.full_name,
        ASISTIO: a.attended ? 'SI' : 'NO',
        ARGUMENTO: a.argument,
        OBSERVACIONES: a.notes
      };
    });
    setAttendancesInfo(info);
  }

  function handleCreateXLS() {
    // Create a new workbook
    const wb = XLSX.utils.book_new();
    // Create a worksheet
    const ws = XLSX.utils.json_to_sheet(attendancesInfo);

    // Set column widths
    const columnWidths = [
      { wpx: 80 }, // Set width of first column to 100 pixels
      { wpx: 120 }, // Set width of second column to 150 pixels
      { wpx: 150 }, // Set width of third column to 120 pixels
      { wpx: 100 },
      { wpx: 100 },
      { wpx: 100 },
      { wpx: 100 },
      { wpx: 100 },
      { wpx: 100 },
      { wpx: 100 },
      { wpx: 150 },
      { wpx: 150 },
      { wpx: 150 }
    ];
    ws['!cols'] = columnWidths;

    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    // Generate a Blob from the workbook
    const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([wbout], { type: 'application/octet-stream' });

    // Create a download link and click it programmatically to download the file
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'asistencias.xlsx';
    link.click();
    URL.revokeObjectURL(url);
  }

  useEffect(() => {
    if (attendances !== null && attendances !== undefined) {
      generateInfo();
    }
  }, [attendances]);

  return (
    <div className={'download-container'}>
      <button onClick={handleCreateXLS} title={'Descargar Asistencias'}>
        <img src={xls} alt='download' />
      </button>
    </div>
  );
}

export default DownloadAttendances;
